import { useState, useEffect } from 'react';
import Button from 'components/base/Button';
import { Col, Row, Alert } from 'react-bootstrap';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import LoadingOverlay from 'components/loading-overlay/LoadingOverlay';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import {
  moveItemStocks,
  getItem,
  getItemStocks,
  getLocations,
  getContainerByLocationId
} from 'api/api';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const customStyles = {
  singleValue: provided => ({
    ...provided,
    fontSize: '12px'
  })
};

function MoveStockWeapon() {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const { state } = useLocation();
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemName, setItemName] = useState(null);
  const { id, stockId } = useParams();
  const customState = state && state.customState;
  const [itemData, setItemData] = useState({
    epc: '',
    serial_number: '',
    cfrn: '',
    tid: ''
  });

  const [locations, setLocations] = useState([]);
  const [containers, setContainers] = useState([]);
  const [location_id, setLocation_id] = useState(null);
  const [container_id, setContainer_id] = useState(null);
  const [location, setLocation] = useState([]);
  const [container, setContainer] = useState([]);
  const [containerId, setContainerId] = useState([]);

  let breadcrumbItems = [];
  if (customState === 'stockItem') {
    breadcrumbItems = [
      {
        label: 'Weapon',
        url: `/weapons/weapons`
      },
      {
        label: 'Weapon Stocks',
        url: `/weapons/stock-weapon/${id}`
      },
      {
        label: 'Move Stock',
        active: true
      }
    ];
  } else if (customState === 'itemDetails') {
    breadcrumbItems = [
      {
        label: 'Weapon Details',
        url: `/weapons/weapon-details/${id}`
      },
      {
        label: 'Move Stock',
        active: true
      }
    ];
  }

  useEffect(() => {
    loadItem();
    loadStock();
    loadLocations();
  }, []);

  const loadItem = () => {
    setLoading(true);

    getItem(id)
      .then(async response => {
        const data = response.data.data;
        console.log(data);
        setItemName(data.name);
        setLocation(data.container.location.name);
        setContainer(data.container.name);
        setContainerId(data.container.id);
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const loadStock = () => {
    setError([]);
    setLoading(true);

    getItemStocks(id)
      .then(response => {
        const stockArray = response.data.data.filter(
          c => c.id === parseInt(stockId)
        );
        if (stockArray.length > 0) {
          setItemData({
            epc: stockArray[0].epc,
            serial_number: stockArray[0].serial_number,
            cfrn: stockArray[0].cfrn,
            tid: stockArray[0].tid
          });
        }
      })

      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const loadLocations = async () => {
    setError([]);

    getLocations()
      .then(response => {
        const data = response.data.data.data;
        setLocations(data);
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });
  };

  const handleChangeLocation = e => {
    loadContainers(e.value);
    setLocation_id(e);
  };

  const loadContainers = async id => {
    setError([]);
    setLoading(true);

    await getContainerByLocationId(id)
      .then(response => {
        const data = response.data.data;
        const filteredContainers = data.filter(
          container => container.id !== containerId
        );
        setContainers(filteredContainers);
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setError([]);
    setLoading(true);

    const formData = {
      container_id: parseInt(container_id.value)
    };

    moveItemStocks(id, stockId, formData)
      .then(response => {
        if (response.status === 200) {
          if (customState === 'stockItem')
            navigate('/weapons/stock-weapon/' + id);
          if (customState === 'itemDetails')
            navigate('/weapons/weapon-details/' + id);
        }
      })
      .catch(err => {
        console.log(err);
        try {
          setError(err.response.data.errors);
        } catch (error) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const handleGoBack = () => {
    if (customState === 'stockItem') navigate('/weapons/stock-weapon/' + id);
    if (customState === 'itemDetails')
      navigate('/weapons/weapon-details/' + id);
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div className="w-100 mb-4">
            <div
              style={{
                background: '#f8f9fa',
                borderRadius: '8px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                minWidth: 320,
                maxWidth: 600
              }}
            >
              <h2 className="mb-3" style={{ fontWeight: 700 }}>
                {`Move '${itemName}' to new location`}
              </h2>

              <div className="mb-2">
                <span style={{ fontWeight: 600 }}>EPC:</span>{' '}
                <span>{itemData.epc || '-'}</span>
              </div>
              <div className="mb-2">
                <span style={{ fontWeight: 600 }}>Serial Number:</span>{' '}
                <span>{itemData.serial_number || '-'}</span>
              </div>
              {itemData.cfrn && (
                <div className="mb-2">
                  <span style={{ fontWeight: 600 }}>CFRN:</span>{' '}
                  <span>{itemData.cfrn}</span>
                </div>
              )}
              {itemData.tid && (
                <div className="mb-2">
                  <span style={{ fontWeight: 600 }}>TID:</span>{' '}
                  <span>{itemData.tid}</span>
                </div>
              )}
              <div className="mb-2">
                <span style={{ fontWeight: 600 }}>Current Location:</span>{' '}
                <span>{location || '-'}</span>
              </div>
              <div>
                <span style={{ fontWeight: 600 }}> Container:</span>{' '}
                <span>{container || '-'}</span>
              </div>
            </div>
          </div>
        </div>
        <Row className="g-5">
          <Col xs={12} xl={8}>
            <div>
              <div>
                {Object.entries(error).length > 0 &&
                  error.map((e, index) => (
                    <Alert variant="soft-danger" key={index}>
                      {e}
                    </Alert>
                  ))}
              </div>

              {loading && <LoadingOverlay />}

              <div>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <label>Destination Location*</label>
                      <Select
                        classNamePrefix="react-select"
                        className="mb-2"
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={
                          locations &&
                          locations.map(c => ({
                            value: c.id,
                            label: c.name
                          }))
                        }
                        onChange={e => handleChangeLocation(e)}
                        value={location_id}
                        required
                        name="location"
                        menuPlacement="auto"
                        styles={customStyles}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <label>Container*</label>
                      <Select
                        classNamePrefix="react-select"
                        className="mb-2"
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={
                          containers &&
                          containers.map(c => ({
                            value: c.id,
                            label: c.name
                          }))
                        }
                        value={container_id}
                        onChange={e => setContainer_id(e)}
                        required
                        name="container"
                        menuPlacement="auto"
                        styles={customStyles}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} xl={4}>
                      <Button className="mb-2" variant="primary" type="submit">
                        Submit
                      </Button>{' '}
                      <Button
                        className="mb-2"
                        variant="phoenix-secondary"
                        type="button"
                        onClick={() => handleGoBack()}
                      >
                        Discard
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default MoveStockWeapon;
